import { render, staticRenderFns } from "./MachineControl.vue?vue&type=template&id=70baa8f5"
import script from "./MachineControl.vue?vue&type=script&lang=js"
export * from "./MachineControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports